<div>
  @switch (question.textEntrytype) {
    @case ('Input Text') {
      <input [disabled]="disabled_" class="form-control" [value]="this.value" type="text" [id]="question.key">
    }
    @case ('Text Area') {
      <textarea [disabled]="disabled_" class="form-control" [value]="this.value" [id]="question.key"></textarea>
    }
    @case ('Numeric') {
      <input [disabled]="disabled_" class="form-control" [value]="this.value" [id]="question.key" type="number">
    }
  }
</div>